/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { CompletedSurvey, NewSurvey, InProgressSurvey } from './components/SurveySummaryBlocks';
import { useSurveysForActiveProfileGroup } from '../../hooks/useSurvey';
import ContentLoader from '../../components/ContentLoader';
import { Card } from '../../../bphComponents/bundle';

interface Props {
  groupId: number;
}

export const GroupSurveys = (props: Props) => {
  const { groupId } = props;

  const [{ definitionsLookup, isLoaded }, surveyActions] = useSurveysForActiveProfileGroup(groupId);
  const surveysByStatus = surveyActions.getGroupSurveysByStatus();

  return (
    <ContentLoader isContentLoaded={isLoaded} isFixed={true}>
      {surveysByStatus.inProgress.map(s => s.completion_percentage
        ? <InProgressSurvey key={s.id} groupId={groupId} survey={s} definition={definitionsLookup[s.survey_definition_id]}/>
        : <NewSurvey key={s.id} groupId={groupId} survey={s} definition={definitionsLookup[s.survey_definition_id]}/>)
      }

      {
        !!surveysByStatus.completed.length &&
        <>
          <Card.ExternalCardTitle>
            <FormattedMessage id="groupSurveys.completedSurveysList.label"/>
          </Card.ExternalCardTitle>

          {surveysByStatus.completed.map(s => <CompletedSurvey key={s.id} groupId={groupId} survey={s} definition={definitionsLookup[s.survey_definition_id]}/>)}
        </>
      }
    </ContentLoader>
  );
};
